import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getEditTagModal = fp.get('inventory.components.editTagModal');

export const getTagItemCount = createSelector(getEditTagModal, fp.get('count'));

export const getIsFetching = createSelector(
  getEditTagModal,
  fp.get('fetching')
);

export const getIsFetched = createSelector(getEditTagModal, fp.get('fetched'));
